<template>
  <div id="SelfReservationAdd">
    <Hero v-if="!isAuth" class="unAuth" src="../assets/faq/hero.jpg" />
    <Wrap>
      <Breadcrumbs
        v-if="project"
        :class="{ padded: isGuest }"
        creationBreadcrumbKey="CAPACITY"
        :project="project"
        :reservationId="reservationId" />
    </Wrap>
    <Loader
      v-if="!project" />

    <Wrap v-if="project && project.status === 'ACTIVE'" class="form-wrap">
      <FormValidation class="form" @submit="submit">
        <div class="SelfReservationAdd-custom-amount">
          <Field
            data-cy="capacity"
            :disabled="isInReviewMode"
            label="Norima saulės elektrinės galia, kW"
            :max="capacityMax"
            :min="1"
            :step="0.1"
            type="number"
            :value.sync="pvCapacity" />
        </div>
        <Btn
          v-if="!isInReviewMode"
          class="arrow"
          data-cy="confirmCapacity"
          :disabled="!pvCapacity || pvCapacity < 1 || pvCapacity > capacityMax"
          type="submit">
          Noriu įsigyti {{ pvCapacity | commaDecimal(1) }} kW
        </Btn>
        <!--
        <Btn
          v-if="!hasCustomCapacity"
          class="inv no-border"
          key="reserve"
          @click="hasCustomCapacity = true">
          Noriu pats nustatyti elektrinės galią
        </Btn>
        -->
      </FormValidation>
    </Wrap>
    <div v-if="!isProjectStarted" class="startDateDisclaimer">
      <Wrap class="lg">
        Šį saulės parką planuojame paleisti {{ startDate.value }}.
        <span v-if="projectsCurrentlyAvailable && projectsCurrentlyAvailable.length">
          <br><br>
          Nenorite laukti?
          <br>
          <Route class="arrow scrollToForm" :to="{ hash: '#jau-veikiantys-parkai' }">
            Pasirinkite jau veikiantį parką
          </Route>
        </span>
      </Wrap>
    </div>
    <Wrap v-if="project" class="lg project">
      <CardProjectDemo :displayNameOverlay="true" :project="project" />
    </Wrap>
    <Calculator
      v-if="project"
      :disabled="isInReviewMode"
      :project="project"
      :value.sync="amount"
      @pvCapacity="setPvCapacity" />
    <Section v-if="projectsCurrentlyAvailable" id="jau-veikiantys-parkai" class="sectionProjectsCurrentlyAvailable">
      <h2>Jau veikiantys parkai</h2>
      <div class="projectsCurrentlyAvailable">
        <CardProject
          v-for="(projectCurrentlyAvailable, index) in projectsCurrentlyAvailable"
          :key="index"
          :project="projectCurrentlyAvailable" />
      </div>
    </Section>
  </div>
</template>

<script>
import { actions, getters } from './utils'
import Breadcrumbs from './components/Breadcrumbs'
import Calculator from './components/Calculator'
import CardProject from './components/CardProject'
import CardProjectDemo from './components/CardProjectDemo'
import Hero from './components/landing/Hero'

export default {
  components: { Breadcrumbs, Calculator, CardProject, CardProjectDemo, Hero },
  data() {
    return {
      amount: 200,
      reservationId: Number(this.$route.params.reservationId),
      // hasCustomCapacity: false,
      pvCapacity: 0,
      capacityMax: 5000,
    }
  },
  computed: {
    isInReviewMode() {
      return !!this.$route.params.reservationId
    },
    project() {
      return this
        .queryOne('project', this.$route.params.id)
    },
    isProjectStarted() {
      const startDate = new Date(this.project.constructionDate)

      return startDate <= new Date()
    },
    startDate() {
      // const dateString = isStarted
      //   ? this.project.startedDate
      //   : this.project.startingDate

      const startDate = new Date(this.project.constructionDate)
      const month = `0${startDate.getMonth() + 1}`.slice(-2)

      return {
        label: this.isStarted
          ? 'Parkas pradėjo veikti'
          : 'Planuojama parko paleidimo data',
        value: `${startDate.getFullYear()} ${month}`,
      }
    },
    projectsCurrentlyAvailable() {
      const nowDate = new Date()
      return this.query('project', {
        constructionDate: {
          $lte: nowDate,
        },
        status: 'ACTIVE',
        $sort: {
          order: 1,
        },
      })
    },
    isGuest() {
      // TODO: hotfix, make layout for guest/better idea
      return this.$route.path.includes('svecias')
    },
    ...getters('localStore'),
  },
  methods: {
    setPvCapacity(pvCapacity) {
      this.pvCapacity = parseFloat(pvCapacity.toFixed(1), 10)
    },
    submit() {
      this.SET_CAPACITY_CACHE(this.pvCapacity)

      this.$router.push({
        name: this.authUser ? 'ReserveUser' : 'ReserveGuest',
        params: {
          amount: Math.round(this.pvCapacity * 100, 10),
          id: this.project.id,
        },
      })
    },
    ...actions('SET_CAPACITY_CACHE'),
  },
  async mounted() {
    if (!this.reservationId) {
      if (this.localStore('capacityCache')) this.setPvCapacity(this.localStore('capacityCache'))

      return
    }

    const reservation = this.queryOne('reservation', this.$route.params.reservationId)
    if (!reservation) return

    this.pvCapacity = reservation.capacity

    await Promise.all([
      this.FETCH_PROJECT(),
    ])
  },
}
</script>

<style lang="scss">
#SelfReservationAdd {
  background: $white-ter;
  padding-bottom: 5rem;

  .Hero {
    min-height: 30vh;
  }

  .Hero.unAuth {
    min-height: 15vh;
  }

  .Breadcrumbs.padded {
    padding-top: 4rem;
  }

  .CardProjectDemo {
    width: 100%;

    .preview {
      height: 16rem;
    }
  }

  .form-wrap {
    margin-bottom: 2rem;
    max-width: 32rem;

    .SelfReservationAdd-custom-amount {
      display: block;

      .Field-cont {
        text-align: center;

        label {
          font-size: $h3;
        }

        input {
          text-align: center;
        }
      }
    }
  }

  .startDateDisclaimer {
    background: $danger-lighter;
    font-weight: $semibold;
    margin-bottom: 4rem;
    margin-top: 1rem;
    padding: 1rem 2rem;
    text-align: center;
    width: 100%;
    @include lg {
      padding: 2rem;
    }
  }

  .sectionProjectsCurrentlyAvailable {
    margin: 0 2rem;
    position: relative;

    h2 {
      @include dotAbove(1.5rem);
      margin: 4rem 0 2rem;
      text-align: center;
    }
  }

  .projectsCurrentlyAvailable {
    display: grid;
    gap: 2rem;
    grid-template-columns: 1fr;
    position: relative;
    @include md {
      grid-template-columns: repeat(2, 1fr);
    }
    @include xl {
      grid-template-columns: repeat(3, 1fr);
    }
  }
}
</style>
